import { Injectable } from '@angular/core';
import { BaseApiService, Result } from '@shared/data-access';
import { TableDataResponse } from '@shared/ui/tables';
import { Observable } from 'rxjs';
import { EvidenceBaseResponse } from '../models/list-evidence.models';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseListEvidenceService {
  constructor(public api: BaseApiService) {}

  abstract listEvidence(query: string): Observable<Result<TableDataResponse<EvidenceBaseResponse>>>;
}
